import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';

@Component({
  selector: 'app-data-table',
  templateUrl: './data-table.component.html',
  styleUrls: ['./data-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataTableComponent implements OnInit {
  // col = {name:'Name', sortable:true, buttons:[{...}]}
  @Input() cols: any;
  @Input() rows: any;
  allRows: any;
  @Input() sort?: string;
  @Input() order?: string = 'asc';
  @Input() page = 1;
  @Input() perPage = 10;
  @Input() tableClass = '';
  @Input() tableId = '';
  @Input() paginationClass = '';
  @Output() buttonEvent: EventEmitter<any> = new EventEmitter();

  search!: string;

  ngOnInit(): void {
    if (!this.sort) {
      this.sort = this.cols[0].id;
    }
  }

  getButtonLink(button: any, col: any, row: any) {
    let link: any = [];
    if (!button.link) {
      return null;
    }
    button.link?.forEach((linkVar: string) => {
      let linkItem;
      if (linkVar.slice(0, 4) == 'row.') {
        linkItem = row[linkVar.slice(4)];
      } else {
        linkItem = linkVar;
      }
      link.push(linkItem);
    });
    return link;
  }

  onSearch() {
    if (!this.allRows) {
      this.allRows = JSON.parse(JSON.stringify(this.rows));
    }
    this.rows = this.allRows.filter((row: any) => {
      let found = false;
      this.cols.forEach((col: any) => {
        let searchItem = row[col.id];
        if (col.dataRef) {
          searchItem = JSON.stringify(row[col.dataRef]);
        }
        if (searchItem) {
          if (
            String(searchItem).toLowerCase().includes(this.search.toLowerCase())
          ) {
            found = true;
          }
        }
      });
      return found;
    });
  }

  sortRows(rows: any) {
    if (!rows) {
      return;
    }
    let sortBy: any = this.sort;

    // transform the rows...
    rows?.forEach((_row: any) => {
      if (_row.user) {
        for (const key of Object.keys(_row.user)) {
          _row['user.' + key] = _row.user[key];
        }
      }

      if (_row.vars) {
        let _vars = JSON.parse(_row.vars);
        _vars.forEach((__var: any) => {
          _row['vars.' + __var.name] = __var.value;
        });
      }
    });

    rows.sort((a: any, b: any) =>
      a[sortBy] > b[sortBy] ? 1 : b[sortBy] > a[sortBy] ? -1 : 0
    );
    if (this.order == 'desc') {
      rows.reverse();
    }
    return rows;
  }

  onSetSort(col: any) {
    if (col.sortable) {
      if (this.sort != col.id) {
        this.order = 'asc';
      } else {
        if (this.order == 'asc') {
          this.order = 'desc';
        } else {
          this.order = 'asc';
        }
      }
      this.sort = col.id;
    }
  }

  onSetPerPage(perPage: number) {
    this.perPage = perPage;
  }

  onButtonPress(button: any, row: any) {
    if (button.hasOwnProperty('action')) {
      return button.action;
    } else if (button.hasOwnProperty('event')) {
      this.buttonEvent.emit({ name: button.event, row: row });
    } else {
      return false;
    }
  }
}
